module.exports = __webpack_public_path__ + "img/instagram.7a007674.jpg";